import { desktopApi, isDesktop } from '../utils';

type CommunicationOptions = {
  ignoreDeviceContext?: boolean;
  channelId?: string;
};

const defaultCommunicationOptions: CommunicationOptions = {
  ignoreDeviceContext: false,
};

export class CommunicationService {
  private ignoreDeviceContext;
  private channelId;

  /**
   * @param options.ignoreDeviceContext - in some cases on desktop we don't want to use desktop communication (ex: TourPreview)
   */
  constructor(options: CommunicationOptions = defaultCommunicationOptions) {
    this.ignoreDeviceContext = options.ignoreDeviceContext;
    this.channelId = options.channelId
      ? Number(options.channelId)
      : window.__DS_TAB_ID;
  }

  public onMessage(cb: (event: MessageEvent<any>) => void): void {
    if (isDesktop && !this.ignoreDeviceContext) {
      desktopApi.tour.onMessage(this.channelId, cb, window.__IS_REPLICATE);
    } else {
      window.addEventListener('message', cb);
    }
  }

  public removeMessageListener(cb: (event: MessageEvent<any>) => void): void {
    if (isDesktop && !this.ignoreDeviceContext) {
      desktopApi.tour.removeEventListener(
        this.channelId,
        window.__IS_REPLICATE
      );
    } else {
      window.removeEventListener('message', cb);
    }
  }

  public postMessage({
    message,
    targetWindow,
    targetOrigin = '*',
  }: {
    message: any;
    targetWindow: Window;
    targetOrigin?: string;
  }): void {
    if (isDesktop && !this.ignoreDeviceContext) {
      desktopApi.tour.postMessage({
        id: this.channelId,
        isReplicate: window.__IS_REPLICATE,
        ...message,
      });
    } else {
      targetWindow?.postMessage(message, targetOrigin);
    }
  }
}
